import React, { useState } from 'react';
import toast from 'react-hot-toast';
import API from '../utils/api';
import { useAuth } from '../context/AuthContext';

const GRAD = 'linear-gradient(135deg, var(--accent), var(--accent2))';

const GENDERS = [
  { value: 'male',   label: '👨 Male'   },
  { value: 'female', label: '👩 Female' },
  { value: 'other',  label: '🌈 Other'  },
];

export default function GenderGate() {
  const { user, updateUser } = useAuth();
  const [selected,   setSelected]   = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!user || user.gender) return null;

  async function handlePick(gender) {
    if (submitting) return;
    setSelected(gender);
    setSubmitting(true);
    try {
      await API.put(`/users/${user.uniqueId}/profile`, { gender });
      updateUser({ gender });
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to save — please try again');
      setSelected('');
      setSubmitting(false);
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.88)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
    }}>
      <div style={{
        width: '100%', maxWidth: 360,
        background: 'var(--panel-bg)',
        borderRadius: 24,
        padding: '32px 24px',
        border: '1px solid var(--border)',
        boxShadow: '0 8px 40px rgba(0,0,0,0.4)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: '2.4rem', marginBottom: 12 }}>🌳</div>
          <h2 style={{
            fontSize: '1.2rem', fontWeight: 800,
            color: 'var(--text)', margin: '0 0 8px',
            fontFamily: 'var(--font-display)',
          }}>
            One quick thing…
          </h2>
          <p style={{ fontSize: '0.85rem', color: 'var(--text3)', margin: 0 }}>
            Tell us who you are to personalize your experience
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {GENDERS.map(({ value, label }) => {
            const isSelected = selected === value;
            return (
              <button
                key={value}
                onClick={() => handlePick(value)}
                disabled={submitting}
                aria-label={value}
                style={{
                  width: '100%', minHeight: 52,
                  borderRadius: 14, border: 'none',
                  background: isSelected ? GRAD : 'var(--bg3)',
                  color: isSelected ? '#fff' : 'var(--text)',
                  fontSize: '1rem', fontWeight: isSelected ? 700 : 500,
                  cursor: submitting ? 'not-allowed' : 'pointer',
                  opacity: submitting && !isSelected ? 0.5 : 1,
                  transition: 'background 0.18s, opacity 0.18s',
                  fontFamily: 'var(--font-body)',
                }}
              >
                {isSelected && submitting ? '…' : label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
